import React from "react";
import PropTypes from "prop-types";

import Typography from '@mui/material/Typography';

const P = ({ children }) => {
  return (
    <Typography paragraph>{children}</Typography>
  )
}

P.propTypes = {
  children: PropTypes.node.isRequired,
}

export default P;
